// src/routes/AppRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import HomePage from '../pages/HomePage';
import About from '../pages/About';
import ContactUs from '../pages/ContactUs';
import Career from '../pages/Career';
import CareerDetails from "../pages/CareerDetails";
import HealthCheckup from "../pages/HealthCheckup";
import HealthCheckupDetails from "../pages/HealthCheckupDetails";
import AcTpas from "../pages/AcTpas";
import Academics from "../pages/Academics";
import Specialities from '../pages/Specialities';
import SpecialitiesDetails from '../pages/SpecialitiesDetails';
import ProcedureDetails from '../pages/ProcedureDetails';
import HealthCheckupComparison from '../pages/HealthCheckupComparison';
import OurDoctors from "../pages/OurDoctors";
import OurDoctorsDetail from '../pages/OurDoctorsDetail';
import Blogs from '../pages/Blogs';
import BlogDetails from '../pages/BlogDetails';
import Events from '../pages/Events';
import EventDetails from '../pages/EventDetails';
import RegulatoryCompliance from '../pages/RegulatoryCompliance';
import OPDSchedule from '../pages/OPDSchedule';
import TakeATour from '../pages/TakeATour';
import TakeATourCarousel from '../pages/TakeATourCarousel';
import PatientTechnology from '../pages/PatientTechnology';
import InternationalPatients from '../pages/InternationalPatients';
import HospitalTechnologService from '../pages/HospitalTechnologService';
import InternalMedicine from '../pages/InternalMedicine';
import TakeTourCarousel from '../pages/TakeTourCarousel';
import NotFound from '../pages/NotFound';
import ScopeOfServices from '../components/ScopeOfServices';
import DiabeticFootSurgeryFellowship from '../components/DiabeticFootSurgeryFellowship';

const AppRoutes = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about-us" element={<About />} />
                <Route path="/corporate-tpa" element={<AcTpas />} />
                <Route path="/academics" element={<Academics />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/international-patients" element={<InternationalPatients />} />
                <Route path="/career" element={<Career />} />
                <Route path="/career/:slug" element={<CareerDetails />} />
                <Route path="/health-checkup" element={<HealthCheckup />} />
                <Route path="/health-checkup/:slug" element={<HealthCheckupDetails />} />
                <Route path="/health-checkup-comparison" element={<HealthCheckupComparison />} />
                <Route path="/specialities" element={<Specialities />} />
                <Route path="/specialities/:slug" element={<SpecialitiesDetails />} />
                <Route path="/specialities/:specialitySlug/procedure/:slug" element={<ProcedureDetails />} />
                <Route path="/doctor" element={<OurDoctors />} />
                <Route path="/doctor/:slug" element={<OurDoctorsDetail />} />
                <Route path="/scope-of-services" element={<ScopeOfServices />} />
                <Route path="/diabetic-foot-surgery-fellowship" element={<DiabeticFootSurgeryFellowship />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/:slug" element={<BlogDetails />} />
                <Route path="/events" element={<Events />} />
                <Route path="/events/:slug" element={<EventDetails />} />
                <Route path="/regulatory-compliance" element={<RegulatoryCompliance />} />
                <Route path="/opd-schedule" element={<OPDSchedule />} />
                {/* <Route path="take-a-tour" element={<TakeATour />} /> */}
                {/* <Route path="/take-a-tour-carousel/:id" element={<TakeATourCarousel />} /> */}
                <Route path="/patient-technology" element={<PatientTechnology />} />
                <Route path="/hospital-technology-service" element={<HospitalTechnologService />} />
                <Route path="/internal-medicine/:id" element={<InternalMedicine />} />
                <Route path="/take-a-tour" element={<TakeTourCarousel />} />
                {/* Add more routes as needed */}

                {/* ✅ 404 Fallback Route — must be last */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    );
};

export default AppRoutes;
